import { useMap } from 'react-leaflet'
import { useEffect } from 'react'

interface IMapUpdaterProps {
  lat: number
  lng: number
}

export const MapUpdater = ({ lat, lng }: IMapUpdaterProps) => {
  const map = useMap()

  useEffect(() => {
    if (lat && lng) {
      map.setView([lat, lng], map.getZoom())
    }
  }, [lat, lng, map])

  return null
}
